export default __webpack_public_path__ + "static/media/07__o_preview_0.4841df4e.jpg";